"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonRoleRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.PersonRoleRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.person_role.label',
    fallbackLabel: 'Role',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'LEGAL_REPRESENTATIVE', label: 'fields.enm.person_role.options.LEGAL_REPRESENTATIVE', fallbackLabel: 'Legal Representative' },
        { key: 'ALTERNATIVE_BENEFICIAL_OWNER', label: 'fields.enm.person_role.options.ALTERNATIVE_BENEFICIAL_OWNER', fallbackLabel: 'Alternative Beneficial Owner' },
        { key: 'ULTIMATE_BENEFICIAL_OWNER', label: 'fields.enm.person_role.options.ULTIMATE_BENEFICIAL_OWNER', fallbackLabel: 'Ultimate Beneficial Owner' },
        { key: 'OWNER', label: 'fields.enm.person_role.options.OWNER', fallbackLabel: 'Owner' },
    ],
    trackFieldValueWithAnalytics: false,
};
